// vendor
import { defineComponent, ref, computed, PropType } from "@vue/composition-api";
// local
import * as Factories from "./factories";
import SectionList from "../vue/section-list.vue";
import FormSection from "../vue/edit-form-section.vue";
import { Form } from "../ts/types";

const shuffleOptions = [
	{ text: "None", value: null, tooltip: "Display all sections" },
	{ text: "Shuffle", value: "shuffle", tooltip: "Display sections in random order" },
	{ text: "Pick One", value: "select", tooltip: "Display one section at random" }
];

export const createComponent = () => {

	return defineComponent({

		props:{
			data:{
				type:Object as PropType<Form>,
				required:true
			}
		},
		components: {
			FormSection,
			SectionList
		},
		setup(props){

			const activeSectionId = ref<string>();
			const allowItemMove = ref(true);

			const activeSectionIndex = computed(() => {
				return props.data.sections.findIndex(s => s.id === activeSectionId.value);
			});

			const sectionCount = computed(() => props.data.sections.length);

			const currentSectionOrder = computed(() => {
				return shuffleOptions.find(o => o.value === sectionSelection.value ) || { value: null, text: "none" };
			});

			const sectionSelection = computed({
				get:() => props.data.settings.sectionSelection,
				set(v){
					props.data.settings.sectionSelection = v;
					// set(props.data.settings, "sectionSelection", v);
				}
			});

			const formData = computed(() => props.data);


			const sections = computed(() => {
				return formData.value ? formData.value.sections : [];
			});

			const activeSection = computed(() => {
				let i = sections.value.findIndex(item => item.id === activeSectionId.value);
				if(i < 0){
					activeSectionId.value = sections.value[0].id;
					i = 0;
				}
				return i > -1 ? sections.value[i] : null;
			});

			const sectionNumber = computed(() => {
				if(!formData.value){ return 0; }
				return sections.value.length;
			});

			
			const addSection = () => {
				if(!formData.value){ return; }
				let s = Factories.createFormSection();
				formData.value.sections.push(s);
				editSection(s.id);
			};

			const addFormItem = async (config:{ section:string, type:string }) => {
				const { section, type } = config;
				let item = await Factories.createFormItem(type);
				let s = sections.value.find(s => s.id === section);
				s?.items.push(item);
			};

			const editSection = (sectionId:string) => {
				activeSectionId.value = sectionId;
			};

			const findItemIndices = (itemId:string) => {
				let i = -1;
				let j = -1;
				for(i = 0; i < sections.value.length; i++){
					for(j = 0; j < sections.value[i].items.length; j++){
		
						if(sections.value[i].items[j].id == itemId){
							return [i, j];
						}
					}
				}
				return null;
			};

			const duplicateItem = (itemId:string) => {
				const res = findItemIndices(itemId);
				if(!res){ return; }
				const section = sections.value[res[0]];
				const item = section.items[res[1]];
				const copy = Factories.duplicateFormItem(item);
				section.items.splice( res[1] + 1, 0, copy );
				editSection(section.id);
			};

			const deleteFormItem = (itemId:string) => {
				const res = findItemIndices(itemId);
				if(!res){ return; }
				const section = sections.value[res[0]];
				section.items.splice(res[1], 1);
			};

			const deleteSection = (sectionId:string) => {
				let i = sections.value.findIndex(s => s.id === sectionId);
				if(!formData.value){ return; }
				formData.value.sections.splice(i, 1);
				const selected = activeSectionId.value === sectionId;
				if(selected){
					let select = i;
					if(select >= sections.value.length){
						select = sections.value.length - 1;
					}
					editSection(formData.value.sections[select].id);
				}
			};

			const duplicateSection = (sectionId:string) => {
				if(!formData.value){ return; }
				const s = sections.value.find(s => s.id === sectionId);
				if(!s){ return; }
				let c = Factories.duplicateFormSection(s);
				formData.value.sections.push(c);
				setTimeout(() => {
					editSection(c.id);
				}, 0.1);
			};

			const init = () => {
				if(formData.value && formData.value.sections.length > 0){
					editSection(formData.value.sections[0].id);
				}
			};

			init();


			return {
				activeSectionId,
				allowItemMove,
				activeSectionIndex,
				sectionCount,
				shuffleOptions,
				formData,
				sectionSelection,
				currentSectionOrder,
				sections,
				activeSection,
				sectionNumber,
				addSection,
				editSection,
				addFormItem,
				duplicateItem,
				deleteFormItem,
				deleteSection,
				duplicateSection

			};
		}

	});
	
}